// The Pipeline, Candidate slate submission, HM advance/hold/pass and the Recruiter screen card's own words (lane B3 S13).
// Every entry quotes his glossary; the D0 label suites discover this module (a lane folder of src/views) and hold it to
// the same rules as src/mc. Words the design system already defines (the seven pipeline columns, the slate and review
// chains, Advance · Hold · Pass, Submit, Record outcome, Original resume …) are imported from it, never redefined here.

import { defineLabels } from "@/mc/labels";

const SLATE = "\"Recruiter submits qualified slate in app; HM receives action-center task and due date.\"";
const REVIEW = "\"Retain Advance, Hold, and Pass. Require reason for Hold and Pass.\"";
const PASS = "\"pass routes disposition\"; \"Pass cannot finish without disposition reason.\"";
const HELD = "\"Statuses / workflow: Pending Review -> Advanced/Held/Passed. Held remains active with age and reason.\"";
const TASK = "\"create a dated HM review task linked to the exact candidates and requisition. Start the HM review SLA.\"";
const OWNS = "\"Recruiter owns screen content and outcome.\" \"Recruiter records outcome.\"";

/** The step names his process uses for the screens of this slice (G §4). */
export const PIPELINE_LABELS = /* @__PURE__ */ defineLabels({
  hmAdvanceHoldPass: { text: "HM advance/hold/pass" },
  candidateSlateSubmission: { text: "Candidate slate submission" },
  hmInterviewSelection: { text: "HM interview selection" },
});

/** His rule sentences: a blocked control's reason, a refusal's banner and a screen's lead line. */
export const PIPELINE_RULES = /* @__PURE__ */ defineLabels({
  slate: { text: "Recruiter submits qualified slate in app; HM receives action-center task and due date." },
  retainAdvanceHoldPass: { text: "Retain Advance, Hold, and Pass." },
  passNeedsReason: { text: "Pass cannot finish without disposition reason." },
  heldAge: { text: "Held remains active with age and reason." },
  datedTask: { text: "create a dated HM review task linked to the exact candidates and requisition." },
  recruiterRecords: { text: "Recruiter records outcome." },
  recruiterOwns: { text: "Recruiter owns screen content and outcome." },
  leadershipStatus: { text: "TA leadership/HRBP see authorized status metrics." },
});
